import EmptyStateIcon from 'components/common/EmptyStateIcon';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Ui from './SelectedItemsEmptyState.styles';

const SelectedItemsEmptyState = ({ onClick }) => {
  const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });

  return (
    <Ui.Container onClick={onClick}>
      <EmptyStateIcon />
      <Ui.Title>{t('noItems')}</Ui.Title>
      <Ui.Subtitle>{t('clickToAdd')}</Ui.Subtitle>
    </Ui.Container>
  );
};

SelectedItemsEmptyState.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default SelectedItemsEmptyState;
